/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Contact_CtaInputs */

const en_faq_contact_cta = /** @type {(inputs: Faq_Contact_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask us directly`)
};

const lv_faq_contact_cta = /** @type {(inputs: Faq_Contact_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzdot jautājumu`)
};

/**
* | output |
* | --- |
* | "Ask us directly" |
*
* @param {Faq_Contact_CtaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_contact_cta = /** @type {((inputs?: Faq_Contact_CtaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Contact_CtaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_contact_cta(inputs)
	return en_faq_contact_cta(inputs)
});